import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import "components/sales/layoutChange/layout.css";

const BrandList = ({ getBrandList, brandData = {}, createDeleteBrand }) => {
  const headers = ["Brand Name", "ERP Code", "Status", "Created At"];

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getBrandList(null, 1);
      setIsLoading(false);
    })();
  }, [getBrandList]);

  useEffect(() => {
  const tableData = ["name", "erp_code", "status", "created_at"];

  if (brandData?.resultSets?.length > 0) {
    const data = brandData.resultSets.map((element) =>
      Object.assign(
        {},
        ...tableData.map((key) => ({
          [key]:
            key === "status"
              ? element.status === 1
                ? "Active"
                : "Inactive"
              : element[key],
        })),
        {}
      )
    );

    setListData(data);
    setPageCount(Math.ceil(brandData.total / brandData.per_page));
  } else {
    setListData([]);
  }
}, [brandData]);


  const onPageChange = async (val) => {
    setIsLoading(true);
    await getBrandList(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <a
          href={`/dashboard/procurement/add_brand`}
          className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
        >+ Add Brand
        </a>
      </Fragment>
    );
  };

  return (
    <Layout
      title="Brand List"
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <div className="row table-margin">
        <div className="col-md-12">
          <TableSection
            data={listData}
            isId={true}
            headers={headers}
            pageCount={pageCount}
            srNo={brandData?.from}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </Layout>
  );
};

export default BrandList;
